export interface IExerciseListQueryArgs {
  page: number;
  pageSize: number;
  searchValue: string;
  categoryIds?: string;
  muscleIds?: string;
  equipmentIds?: string;
  developedSkillIds?: string;
}

export function buildExerciseListUrlParams(args: IExerciseListQueryArgs) {
  const params: Record<string, string | number> = {
    page: args.page,
    pageSize: args.pageSize,
    searchValue: args.searchValue ?? '',
  };
  if (args.categoryIds) {
    params.categoryIds = args.categoryIds;
  }
  if (args.muscleIds) {
    params.muscleIds = args.muscleIds;
  }
  if (args.equipmentIds) {
    params.equipmentIds = args.equipmentIds;
  }
  if (args.developedSkillIds) {
    params.developedSkillIds = args.developedSkillIds;
  }
  return params;
}

export function serializeExerciseListQueryArgs(args: IExerciseListQueryArgs) {
  return [
    args.page,
    args.pageSize,
    args.searchValue,
    args.categoryIds ?? '',
    args.muscleIds ?? '',
    args.equipmentIds ?? '',
    args.developedSkillIds ?? '',
  ].join('|');
}
